import { Link } from "react-router-dom";
import abutShape3 from "../../images/about/shape-2.png"

const ClickHandler = () => {
    window.scrollTo(10, 0)
}

const AboutSection5 = () => {
    return (
        <section className="wpo-about-section-s3 section-padding">
            <div className="container">
                <div className="wpo-about-wrap">
                    <div className="row align-items-center">
                        <div className="col-lg-6 col-md-12 col-12">
                            <div className="wpo-about-img-s3">
                                <div className="image">
                                    <img src={"/abt.webp"} alt="" />
                                    {/* <div className="shape">
                                        <img src={abutShape3} alt="" />
                                    </div> */}
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-6 col-md-12 col-12">
                            <div className="wpo-about-text">
                                 <div className="wpo-section-title">
                                    {/* <span>Welcome to Heart-to-Heart Children Aid</span> */}
                                    <h2>Heart to Heart Children’s Aid Completes Life-Saving Cardiac Surgeries for 207 Children</h2>
                                </div>
                                    <p>Heart to Heart Children’s Aid is proud to announce the successful completion of free life-saving cardiac surgeries for 207 children across Ethiopia from April 20 to June 10, 2026. This humanitarian initiative was made possible through the collaboration with Ethio-Istanbul General Hospital, the Ethiopian Ministry of Health, UNA VOCE PER PADRE PIO, and CENTRO CARDIOLOGICO PEDIATRICO DEL MEDITERRANEO, funded by donations raised during the fundraising event held in Washington, DC on March 21, 2026.</p>
                                    <p>The surgeries and treatments were conducted in seven different locations across the country, including Ethio-Istanbul General Hospital, Jigjiga, Gonder, Jimma, Tikur Anbessa Referral Hospital, Cardiac Center Ethiopia, and St. Paul’s Hospital Millennium Medical College.</p>
                                    <p>We extend our heartfelt gratitude to all donors and partners who made this life-saving mission possible. Your generosity has given hundreds of children a second chance at life. We encourage everyone to continue supporting our mission through ongoing donations to help save even more children in need.</p>

                                {/* <div className="about-btn">
                                    <a href="Memorandum-of-understanding.pdf" className="theme-btn" onClick={ClickHandler} target="_blank" rel="noopener noreferrer">
                                        See More
                                    </a>
                                   
                                </div> */}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    )
}

export default AboutSection5;